import apisaucePlugin from 'reactotron-apisauce'
import Reactotron from 'reactotron-react-js'
import { reactotronRedux } from 'reactotron-redux'

const tron = Reactotron.configure().use(reactotronRedux()).use(apisaucePlugin()).connect()

tron.clear()

console.tron = tron

export default tron
